// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"b958f458","71":"74a615e7","128":"2d402ae9","140":"00111629","147":"1b2f0f3f","231":"95360113","454":"c66611a7","460":"6083f215","562":"688f38a8","675":"ace486e7","825":"3c3e6d9a","968":"73edc0f0","996":"45d67c9c"}[chunkId] + ".chunk.js";
};